export default __webpack_public_path__ + "static/media/outbound.1149e2d2.png";